import React, { useContext } from "react";
import UserContext from "../../../../context/UserContext";
import { useCompanies } from "../../../../context/CompanyContext";
import FeatureSearch from "./FeatureSearch/FeatureSearch";
import FeatureActionButton from "./FeatureActionButton/FeatureActionButton";
import classes from "./FeatureHeader.module.scss";
import USER_ROLES from "../../../../constants/userRoles";
import FeatureFilterButton from "./FeatureFilterButton/FeatureFilterButton";
import FeatureSelector from "./FeatureSelector/FeatureSelector";
import FeatureDisplay from "./FeatureDisplay/FeatureDisplay";

const FeatureHeader = ({
  t,
  title,
  search,
  selectors = [],
  display,
  filters,
  actionButton,
  showCompanySelector = false,
  selectedCompany = "",
  onCompanyChange = () => {},
  selectorUniqeClassname,
}) => {
  const { user } = useContext(UserContext);
  const { companies, loading } = useCompanies();
  const userRole = parseInt(user?.roles);
  const isSuperAdmin = user && user.roles === USER_ROLES.SUPER_ADMIN;

  return (
    <section className={classes["feature-header"]}>
      <div className={classes["feature-header__1st-row"]}>
        <h2>{title}</h2>
        {search && <FeatureSearch t={t} search={search} />}
      </div>
      <div className={classes["feature-header__2nd-row"]}>
        <div className={classes["feature-header__2nd-row__left"]}>
          {/* --- SUPER ADMIN COMPANY SELECTOR ---  */}
          {/* Render selectors based on role requirements */}
          {selectors.map((selector, index) => {
            // Show if no requiredRole is set, or if user's role is <= requiredRole
            // (Remember: lower number = higher privilege)
            const canSeeCompanySelector =
              selector.requiredRole === undefined ||
              userRole <= selector.requiredRole;

            return canSeeCompanySelector ? (
              <FeatureSelector
                key={index}
                t={t}
                items={selector.items}
                loading={selector.loading}
                selectedValue={selector.selectedValue}
                onChange={selector.onChange}
                valueField={selector.valueField}
                labelField={selector.labelField}
                placeholderKey={selector.placeholderKey}
                icon={selector.icon}
                maxWidth={selector.maxWidth}
                className={selectorUniqeClassname || ""}
              />
            ) : null;
          })}
        </div>
        <div className={classes["feature-header__2nd-row__right"]}>
          {display && (
            <FeatureDisplay
              t={t}
              displayCount={display.count}
              onChange={display.onChange}
              options={display.options}
            />
          )}

          {filters && <FeatureFilterButton t={t} filterContent={filters} />}

          {actionButton && (
            <FeatureActionButton
              t={t}
              onClick={actionButton.onClick}
              icon={actionButton.icon}
              label={actionButton.label}
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default FeatureHeader;
